<template>
  <v-content class="pa-12">
    <v-layout justify-space-around>
      <v-flex
        d-flex
        justify-start
        align-center
        style="color: #3E7662;font-weight: bold;font-size: 24px;"
      >
        <span>Post Approve</span>
      </v-flex>
    </v-layout>

    <v-row>
      <v-col cols="4">
        <v-text-field
          clearable
          @click:clear="onClearable"
          placeholder="ชื่อคณะอนุกรรมการ"
          color="#3e7662"
          dense
          outlined
          v-model="name"
          hide-details
        />
      </v-col>
      <v-col class="shrink d-flex align-center justify-end">
        <v-btn color="#3e7662" dark @click="getSubcommittee(1)">
          <span class="font-weight-bold">ค้นหา</span>
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <!-- Table -->
    <v-layout mt-4>
      <v-flex>
        <form-table
          :headers="headers"
          :items="researchList"
          onView
          typeSubcommittee
        ></form-table>
      </v-flex>
    </v-layout>

    <!-- Pagination -->
    <v-layout mt-12>
      <v-flex>
        <v-pagination
          color="#3E7662"
          :length="paginateSubcommittee.last_page"
          :total-visible="9"
          @input="getSubcommittee"
          v-model="paginateSubcommittee.current_page"
        ></v-pagination>
      </v-flex>
    </v-layout>

    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
    ></loading>
  </v-content>
</template>

<script>
import FormTable from "../../../components/table/FormTable";
import vSelect from "vue-select";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-select/dist/vue-select.css";
import { mapState } from "vuex";
export default {
  name: "Meeting",
  components: {
    FormTable,
    vSelect,
    Loading,
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  data: () => ({
    name: "",
    meetingDialog: false,
    isLoading: false,
    fullPage: true,
    paginateSubcommittee: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    headers: [
      {
        text: "ลำดับ",
        value: "number",
        align: "center",
        width: "10%",
        sortable: false,
      },
      { text: "ชื่อคณะอนุกรรมการ", value: "SubcommitteeName", align: "center" },
      {
        text: "ดูข้อมูล",
        value: "view",
        align: "center",
        width: "10%",
        sortable: false,
      },
    ],
    researchList: [],
  }),
  created() {
    // Check Permission Access
    //if (this.user.currentRole !== 3) {
    //     this.$router.go(-1);
    //}
    this.getSubcommittee(1);
  },
  methods: {
    onClearable() {
      this.name = "";
      this.getSubcommittee(1);
    },
    getSubcommittee(page) {
      this.isLoading = true;
      this.researchList = [];
      let payload = {
        page: page,
        keyword: this.name,
      }
      if(this.user.currentRole === 3){
        payload.keyword = this.user.thName;
      }

      this.$store
        .dispatch("Research/getSubcommittee", payload)
        .then((res) => {
          // console.log('data res', res)
          let i = 1;
          res.data.forEach((data) => {
            this.researchList.push({
              number: i,
              id: data.id,
              SubcommitteeName: data.preNameTh ? data.preNameTh + " " + data.thName : data.thName,
              linkView: "ViewDataPostApprove",
            });
            i++;
          });
          this.paginateSubcommittee.current_page = res.current_page;
          this.paginateSubcommittee.from = res.from;
          this.paginateSubcommittee.last_page = res.last_page;
          this.paginateSubcommittee.per_page = res.per_page;
          this.paginateSubcommittee.total = res.total;
          this.paginateSubcommittee.to = res.to;
          this.isLoading = false;
        });
    },
    changeStatusMeeting(data) {
      this.meetingDialog = true;
      this.isLoading = true;
      this.$store
        .dispatch("Meeting/getJoinMeeting", data.id)
        .then((res) => {
          this.meetingForm.meetingID = data.id;
          this.meetingForm.meetingName = data.meetingName;
          this.meetingForm.meetingDate = data.meetingDate;
          this.meetingForm.meetingPlace = data.location;
          this.meetingForm.meetingTime = data.time;
          this.meetingForm.isJoin = res.isJoin.toString();
        })
        .then(() => {
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    updateStatusMeeting() {
      this.$store
        .dispatch("Meeting/updateStatusMeeting", this.meetingForm)
        .then((res) => {
          Swal.fire({
            title: "บันทึกเรียบร้อยแล้ว",
            icon: "success",
            position: "center",
            showConfirmButton: false,
            background: "#FAF5F2",
          });
          this.meetingDialog = false;
          window.location.reload();
        })
        .catch((e) => {
          this.isLoading = false;
          if (e.response.data.errors) {
            for (var k in e.response.data.errors) {
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: e.response.data.errors[k][0],
                icon: "warning",
                confirmButtonColor: "#3E7662",
              }).then(() => {
                this.$vuetify.goTo(`#${k}`);
              });
            }
          }
          // Swal.fire({
          //     title: "เกิดข้อผิดพลาด",
          //     text: "บันทึกไม่สำเร็จ",
          //     icon: 'warning'
          // });
        });
    },
  },
};
</script>

<style lang="scss">
// V-select
.style-chooser .vs__search::placeholder,
    .style-chooser .vs__dropdown-toggle,
    .style-chooser .vs__selected
        /*.style-chooser .vs__dropdown-menu:hover*/
 {
  background: #3e7662;
  border: solid 2px #3e7662;
  color: #fff;
  /*text-transform: lowercase;*/
  /*font-variant: small-caps;*/
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #fff;
}
.radio-checked label.v-label.theme--light {
  color: #3e7662;
}
</style>
